// @flow

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ResponsiveImage from '../responsiveImage';
import { rewriteUrl } from '../../helpers';
import type { Theme } from '../../types';

type ImageProps = {
  alt?: string,
  originalImgWidth?: ?number,
  position: string;
  src: string,
  srcSet?: ?Array<{|
    width: number,
    url: string,
  |}>,
};

type LinkImageProps = {
  page?: ?string,
  url?: ?string,
};

type LinkProps = ImageProps & LinkImageProps;

const StyledImage = styled<any, Theme>('img')`
  max-width: 100%;
  align-self: center;
`;

type ContainerProps = {
  position: string;
};

const ImageContainer = styled<any, Theme, ContainerProps>('section')`
  display: flex;
  justify-content: ${props => props.position};

  /*
    Add 100% to div to fix ie11 bug.
    Because the div is a ref i can't make the div a styled component
  */
  > div {
    @media all and (-ms-high-contrast:none) {
      width: 100%;
      min-height: 1px;
    }
  }
`;

const Image = ({
  src,
  srcSet,
  alt,
  originalImgWidth,
  position,
}: ImageProps) => (
  <ImageContainer position={position}>
    {srcSet
      ? <ResponsiveImage
        alt={alt}
        originalImgWidth={originalImgWidth}
        src={src}
        srcSet={srcSet}
      />
      : <StyledImage src={src} alt={alt} />}
  </ImageContainer>
);

Image.defaultProps = {
  alt: '',
  originalImgWidth: null,
  srcSet: null,
};

const LinkImage = ({
  url,
  page,
  ...imageProps
}: LinkProps) => {
  if (page) {
    return (
      <Link to={{ pathname: rewriteUrl(page) }}>
        <Image {...imageProps} />
      </Link>
    );
  }
  if (url) {
    return (
      <a href={url}>
        <Image {...imageProps} />
      </a>
    );
  }
  return (
    <Image {...imageProps} />
  );
};

LinkImage.defaultProps = {
  url: null,
  page: null,
  alt: '',
  originalImgWidth: null,
  srcSet: null,
};

export default LinkImage;
